<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="items">
      <!-- 中文简体 -->
      <div
          class="item van-hairline--bottom"
          @click="changeLang('zh')"
      >
        <div class="flex_center">
          <div class="info">中文简体</div>
        </div>

        <div v-if="lang === 'zh'" class="check">✓</div>
      </div>

      <!-- 中文繁体 -->
      <div
          class="item van-hairline--bottom"
          @click="changeLang('tw')"
      >
        <div class="flex_center">
          <div class="info">中文繁體</div>
        </div>

        <div v-if="lang === 'tw'" class="check">✓</div>
      </div>

      <!-- English -->
      <div
          class="item van-hairline--bottom"
          @click="changeLang('en')"
      >
        <div class="flex_center">
          <div class="info">English</div>
        </div>

        <div v-if="lang === 'en'" class="check">✓</div>
      </div>

      <!-- Melayu -->
      <div
          class="item van-hairline--bottom"
          @click="changeLang('ja')"
      >
        <div class="flex_center">
          <div class="info">Melayu</div>
        </div>

        <div v-if="lang === 'ja'" class="check">✓</div>
      </div>

      <!-- 韩语 -->
      <div
          class="item van-hairline--bottom"
          @click="changeLang('kr')"
      >
        <div class="flex_center">
          <div class="info">한국어</div>
        </div>

        <div v-if="lang === 'kr'" class="check">✓</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "Language",

  data() {
    return {
      lang: this.$i18n.locale,
      source: ""
    };
  },

  created() {
    this.replaceLang();
  },

  mounted() {
    this.source = this.$route.params.type;
  },

  methods: {
    back() {
      return window.history.back();
    },

    replaceLang() {
      this.$http({
        method: "get",
        url: "replaceLang",
        data: {
          lang: this.lang
        }
      }).then((res) => {
        console.log(res, 11);
      });
    },

    changeLang(lang) {
      Toast.loading({
        duration: 200
      });

      // 当前语言
      this.lang = lang;

      // vue-i18n 切换语言
      this.$i18n.locale = lang;

      // 通知后端
      this.replaceLang();

      // 保存到本地
      localStorage.setItem("lang", lang);

      if (this.source === "setting") {
        this.$router.push({
          path: "/"
        });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.container .items {
  background-color: #fff;
  font-size: 30px;
  color: #000;
  padding: 25px;
}

.container .items .item {
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}

.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
  padding: 10px 0;
}

.container .sign-out {
  margin: 500px 20px 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}

.container .item .desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}

.container .item .right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex_center {
  display: flex;
  align-items: center;
}

.flex_center img {
  width: 60px;
  height: 60px;
  margin-right: 20px;
}

.check {
  font-size: 32px;
  font-weight: bold;
  color: #e43e83;
}
</style>